import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import { Uploader } from 'components/Uploader';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useEditPage from 'hooks/useEditPage';
import MasterDetailPages from './MasterDetailPages';
const GoldloancontractEditPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	// form validation schema
	const validationSchema = yup.object().shape({
		loanaccountno: yup.string().required().label($t('loanAccountNo')),
		memberid: yup.string().nullable().label($t('membeid')),
		branchcode: yup.string().required().label($t('branchCode')),
		schemeid: yup.string().required().label($t('schemeId')),
		interestrate: yup.string().required().label($t('interestRate')),
		loanamount: yup.string().required().label($t('loanAmount')),
		disbursementdate: yup.string().nullable().label($t('disbursementDate')),
		first_emi_date: yup.string().nullable().label($t('firstEmiDate')),
		amort_type: yup.string().nullable().label($t('amortType')),
		loanpaymentamountdue: yup.string().required().label($t('emi')),
		loanterm: yup.number().nullable().label($t('loanTerm')),
		loanpaymentfrequency: yup.string().nullable().label($t('frequency')),
		amountdisbursed: yup.number().required().label($t('amountDisbursed')),
		chequeno: yup.string().nullable().label($t('chequeno')),
		ac_code: yup.string().nullable().label($t('acCode')),
		processingfee: yup.string().nullable().label($t('processingFee')),
		insurancefee: yup.string().nullable().label($t('insuranceFee')),
		policy_number_bor: yup.string().nullable().label($t('policyNumber')),
		name_insurance: yup.string().nullable().label($t('nameInsurance')),
		insu_start_bor: yup.string().nullable().label($t('insuStart')),
		insu_end_bor: yup.string().nullable().label($t('insuEnd')),
		ac_closed: yup.number().nullable().label($t('acClosed')),
		date_closed: yup.string().nullable().label($t('dateClosed')),
		empcode: yup.string().nullable().label($t('empcode')),
		lender_image: yup.string().nullable().label($t('lenderImage')),
		created_by: yup.number().nullable().label($t('createdBy')),
		checked_by: yup.number().nullable().label($t('checkedBy')),
		created_on: yup.string().nullable().label($t('createdOn')),
		updated_on: yup.string().nullable().label($t('updatedOn')),
		outstandingprincipal: yup.number().nullable().label($t('outstandingprincipal')),
		datecontractends: yup.string().nullable().label($t('datecontractends'))
	});
	// form default values
	const formDefaultValues = {
		loanaccountno: utils.randomNum(10), 
		memberid: '', 
		branchcode: '', 
		schemeid: '', 
		interestrate: '', 
		loanamount: '', 
		disbursementdate: new Date(), 
		first_emi_date: new Date(), 
		amort_type: '', 
		loanpaymentamountdue: '', 
		loanterm: '', 
		loanpaymentfrequency: '', 
		amountdisbursed: '', 
		chequeno: '', 
		ac_code: '', 
		processingfee: '', 
		insurancefee: '', 
		policy_number_bor: '', 
		name_insurance: '', 
		insu_start_bor: new Date(), 
		insu_end_bor: new Date(), 
		ac_closed: "((0))", 
		date_closed: new Date(), 
		empcode: '', 
		lender_image: '', 
		created_by: auth.userId, 
		checked_by: auth.userId, 
		created_on: new Date(), 
		updated_on: new Date(), 
		outstandingprincipal: '', 
		datecontractends: new Date(), 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, currentRecord, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/goldloancontract`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="GoldloancontractEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editGoldloancontract')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <div className="grid ">
                            <div className="col">
                                <Formik
                                    initialValues={formData}
                                    validationSchema={validationSchema} 
                                    onSubmit={(values, actions) => {
                                    submitForm(values);
                                    }
                                    }
                                    >
                                    { (formik) => {
                                    return (
                                    <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                        <div className="grid">
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('loanAccountNo')} *
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="loanaccountno"  onChange={formik.handleChange}  value={formik.values.loanaccountno}   label={$t('loanAccountNo')} type="text" placeholder={$t('enterLoanAccountNo')}     disabled   className={inputClassName(formik?.errors?.loanaccountno)} />
                                                        <ErrorMessage name="loanaccountno" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('membeid')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <DataSource   apiPath="components_data/memberid_option_list_2"  >
                                                            {
                                                            ({ response }) => 
                                                            <>
                                                            <Dropdown  name="memberid"     optionLabel="label" optionValue="value" value={formik.values.memberid} onChange={formik.handleChange} options={response} label={$t('membeid')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.memberid)}   />
                                                            <ErrorMessage name="memberid" component="span" className="p-error" />
                                                            </>
                                                            }
                                                        </DataSource>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('branchCode')} *
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <DataSource   apiPath="components_data/branchcode_option_list"  >
                                                            {
                                                            ({ response }) => 
                                                            <>
                                                            <Dropdown  name="branchcode"     optionLabel="label" optionValue="value" value={formik.values.branchcode} onChange={formik.handleChange} options={response} label={$t('branchCode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.branchcode)}   />
                                                            <ErrorMessage name="branchcode" component="span" className="p-error" />
                                                            </>
                                                            }
                                                        </DataSource>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('schemeId')} *
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <DataSource   apiPath="components_data/schemeid_option_list"  >
                                                            {
                                                            ({ response }) => 
                                                            <>
                                                            <Dropdown  name="schemeid"     optionLabel="label" optionValue="value" value={formik.values.schemeid} onChange={formik.handleChange} options={response} label={$t('schemeId')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.schemeid)}   />
                                                            <ErrorMessage name="schemeid" component="span" className="p-error" />
                                                            </>
                                                            }
                                                        </DataSource>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('interestRate')} *
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="interestrate"  onChange={formik.handleChange}  value={formik.values.interestrate}   label={$t('interestRate')} type="text" placeholder={$t('enterInterestRate')}     disabled   className={inputClassName(formik?.errors?.interestrate)} />
                                                        <ErrorMessage name="interestrate" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('loanAmount')} *
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="loanamount"  onChange={formik.handleChange}  value={formik.values.loanamount}   label={$t('loanAmount')} type="text" placeholder={$t('enterLoanAmount')}        className={inputClassName(formik?.errors?.loanamount)} />
                                                        <ErrorMessage name="loanamount" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('disbursementDate')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <Calendar name="disbursementdate" showButtonBar className={inputClassName(formik?.errors?.disbursementdate)} dateFormat="yy-mm-dd" value={formik.values.disbursementdate} onChange={formik.handleChange} showIcon        />
                                                        <ErrorMessage name="disbursementdate" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('firstEmiDate')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <Calendar name="first_emi_date" showButtonBar className={inputClassName(formik?.errors?.first_emi_date)} dateFormat="yy-mm-dd" value={formik.values.first_emi_date} onChange={formik.handleChange} showIcon        />
                                                        <ErrorMessage name="first_emi_date" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('amortType')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <Dropdown  name="amort_type"     optionLabel="label" optionValue="value" value={formik.values.amort_type} onChange={formik.handleChange} options={app.menus.amortType2} label={$t('amortType')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.amort_type)}   />
                                                        <ErrorMessage name="amort_type" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('emi')} *
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="loanpaymentamountdue"  onChange={formik.handleChange}  value={formik.values.loanpaymentamountdue}   label={$t('emi')} type="text" placeholder={$t('enterEmi')}     disabled   className={inputClassName(formik?.errors?.loanpaymentamountdue)} />
                                                        <ErrorMessage name="loanpaymentamountdue" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('loanTerm')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="loanterm"  onChange={formik.handleChange}  value={formik.values.loanterm}   label={$t('loanTerm')} type="number" placeholder={$t('enterLoanTerm')}  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.loanterm)} />
                                                        <ErrorMessage name="loanterm" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('frequency')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="loanpaymentfrequency"  onChange={formik.handleChange}  value={formik.values.loanpaymentfrequency}   label={$t('frequency')} type="text" placeholder={$t('enterFrequency')}     disabled   className={inputClassName(formik?.errors?.loanpaymentfrequency)} />
                                                        <ErrorMessage name="loanpaymentfrequency" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('amountDisbursed')} *
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="amountdisbursed"  onChange={formik.handleChange}  value={formik.values.amountdisbursed}   label={$t('amountDisbursed')} type="number" placeholder={$t('enterAmountDisbursed')}  min={0}  step={0.1} disabled   className={inputClassName(formik?.errors?.amountdisbursed)} />
                                                        <ErrorMessage name="amountdisbursed" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('chequeno')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="chequeno"  onChange={formik.handleChange}  value={formik.values.chequeno}   label={$t('chequeno')} type="text" placeholder={$t('enterChequeno')}        className={inputClassName(formik?.errors?.chequeno)} />
                                                        <ErrorMessage name="chequeno" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('acCode')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <DataSource   apiPath="components_data/ac_code_option_list"  >
                                                            {
                                                            ({ response }) => 
                                                            <>
                                                            <Dropdown  name="ac_code"     optionLabel="label" optionValue="value" value={formik.values.ac_code} onChange={formik.handleChange} options={response} label={$t('acCode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.ac_code)}   />
                                                            <ErrorMessage name="ac_code" component="span" className="p-error" />
                                                            </>
                                                            }
                                                        </DataSource>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('processingFee')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="processingfee"  onChange={formik.handleChange}  value={formik.values.processingfee}   label={$t('processingFee')} type="text" placeholder={$t('enterProcessingFee')}     disabled   className={inputClassName(formik?.errors?.processingfee)} />
                                                        <ErrorMessage name="processingfee" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('insuranceFee')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="insurancefee"  onChange={formik.handleChange}  value={formik.values.insurancefee}   label={$t('insuranceFee')} type="text" placeholder={$t('enterInsuranceFee')}     disabled   className={inputClassName(formik?.errors?.insurancefee)} />
                                                        <ErrorMessage name="insurancefee" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('policyNumber')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="policy_number_bor"  onChange={formik.handleChange}  value={formik.values.policy_number_bor}   label={$t('policyNumber')} type="text" placeholder={$t('enterPolicyNumber')}        className={inputClassName(formik?.errors?.policy_number_bor)} />
                                                        <ErrorMessage name="policy_number_bor" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('nameInsurance')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="name_insurance"  onChange={formik.handleChange}  value={formik.values.name_insurance}   label={$t('nameInsurance')} type="text" placeholder={$t('enterNameInsurance')}        className={inputClassName(formik?.errors?.name_insurance)} />
                                                        <ErrorMessage name="name_insurance" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('insuStart')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <Calendar name="insu_start_bor" value={formik.values.insu_start_bor} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.insu_start_bor)}        />
                                                        <ErrorMessage name="insu_start_bor" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('insuEnd')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <Calendar name="insu_end_bor" value={formik.values.insu_end_bor} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.insu_end_bor)}        />
                                                        <ErrorMessage name="insu_end_bor" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('acClosed')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="ac_closed"  onChange={formik.handleChange}  value={formik.values.ac_closed}   label={$t('acClosed')} type="number" placeholder={$t('enterAcClosed')}  min={0}  step="any"    className={inputClassName(formik?.errors?.ac_closed)} />
                                                        <ErrorMessage name="ac_closed" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('dateClosed')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <Calendar name="date_closed" value={formik.values.date_closed} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.date_closed)}        />
                                                        <ErrorMessage name="date_closed" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('empcode')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <DataSource   apiPath="components_data/empcode_option_list"  >
                                                            {
                                                            ({ response }) => 
                                                            <>
                                                            <Dropdown  name="empcode"     optionLabel="label" optionValue="value" value={formik.values.empcode} onChange={formik.handleChange} options={response} label={$t('empcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.empcode)}   />
                                                            <ErrorMessage name="empcode" component="span" className="p-error" />
                                                            </>
                                                            }
                                                        </DataSource>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('lenderImage')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <div className={inputClassName(formik?.errors?.lender_image)}>
                                                            <Uploader name="lender_image" showUploadedFiles value={formik.values.lender_image} uploadPath="fileuploader/upload/lender_image" onChange={(paths) => formik.setFieldValue('lender_image', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label={$t('chooseFilesOrDropFilesHere')} onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                        </div>
                                                        <ErrorMessage name="lender_image" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="md:col-6 col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('createdBy')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="created_by"  onChange={formik.handleChange}  value={formik.values.created_by}   label={$t('createdBy')} type="number" placeholder={$t('enterCreatedBy')}  min={0}  step="any"    className={inputClassName(formik?.errors?.created_by)} />
                                                        <ErrorMessage name="created_by" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('checkedBy')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="checked_by"  onChange={formik.handleChange}  value={formik.values.checked_by}   label={$t('checkedBy')} type="number" placeholder={$t('enterCheckedBy')}  min={0}  step="any"    className={inputClassName(formik?.errors?.checked_by)} />
                                                        <ErrorMessage name="checked_by" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('createdOn')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <Calendar name="created_on" value={formik.values.created_on} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.created_on)}        />
                                                        <ErrorMessage name="created_on" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('updatedOn')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <Calendar name="updated_on" value={formik.values.updated_on} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.updated_on)}        />
                                                        <ErrorMessage name="updated_on" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('outstandingprincipal')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <InputText name="outstandingprincipal"  onChange={formik.handleChange}  value={formik.values.outstandingprincipal}   label={$t('outstandingprincipal')} type="number" placeholder={$t('enterOutstandingprincipal')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.outstandingprincipal)} />
                                                        <ErrorMessage name="outstandingprincipal" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="formgrid grid">
                                                    <div className="col-12 md:col-3">
                                                        {$t('datecontractends')} 
                                                    </div>
                                                    <div className="col-12 md:col-9">
                                                        <Calendar name="datecontractends" showButtonBar className={inputClassName(formik?.errors?.datecontractends)} dateFormat="yy-mm-dd" value={formik.values.datecontractends} onChange={formik.handleChange} showIcon        />
                                                        <ErrorMessage name="datecontractends" component="span" className="p-error" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        { props.showFooter && 
                                        <div className="text-center my-3">
                                            <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                        </div>
                                        }
                                    </Form>
                                    );
                                    }
                                    }
                                    </Formik>
                                </div>
                                {
                                (currentRecord && !props.isSubPage) && 
                                <div className="col-12">
                                    <div className="card my-3">
                                        <MasterDetailPages masterRecord={currentRecord} scrollIntoView={false} />
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
GoldloancontractEditPage.defaultProps = {
	primaryKey: 'loanaccountno',
	pageName: 'goldloancontract',
	apiPath: 'goldloancontract/edit',
	routeName: 'goldloancontractedit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default GoldloancontractEditPage;
